import { createContext, RefObject } from 'react';

const Context = createContext<{
  containerRef: RefObject<HTMLDivElement>;
  onPositionChange: (x: number) => void;
  setTitle: (title: string) => void;
  setNbPlans: (nbPlans: number) => void;
  setIsExpanded: (isExpanded: boolean) => void;
  setContent: (content: React.ReactNode) => void;
}>({
  containerRef: { current: null },
  onPositionChange: () => null,
  setContent: () => null,
  setIsExpanded: () => null,
  setNbPlans: () => null,
  setTitle: () => null,
});

export default Context;
